<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <query v-model="query" keyword="名稱">
                    <div class="col-md col-sm-12">
                        <form-select v-model="query.property" id="track" label="屬性">
                            <div is="option" value="">全部</div>
                            <div is="option" v-for="o in propertys" :key="o.key" :value="o.key">{{o.value}}</div>
                        </form-select>
                    </div>
                </query>
                <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length" :input="input"></btn-group>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>屬性</th>
                            <th>名稱</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.CommunityID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.CommunityID" /></td>
                        <td data-th="屬性">{{item.Property|property}}</td>
                        <td data-th="名稱"><b-button size="sm" variant="link" @click="edit(item.CommunityID)">{{item.Name}}</b-button></td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit">
            <template slot="propertys">
                <div is="option" v-for="o in propertys" :key="o.key" :value="o.key">{{o.value}}</div>
            </template>
        </Detail>
        <inputmodal id="input" sample="/template/community.xlsx" url="/api/community/excel" @ok="reload()"></inputmodal>
    </page-main>
</template>

<script>
    import Detail from './communityDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'community',
        api: '/api/community/',
        components: { Detail },
        data: { propertys: [] },
        created: function () {
            window.propertys = [];
            this.$parameter.communityproperty().then((res) => { window.propertys = this.propertys = res.data; });
        },
        filters: {
            property: function (value) { let a = window.propertys.filter(x => x.key == value); return a.length > 0 ? a[0].value : ''; }
        },
    });
</script>

<style>
</style>